import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
//import Breadcrumbs
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DataTableHelper from "../../helpers/tables/DataTableHelper"
import Columns from './Columns'
import AddUpdModal from './AddUpdModal'
import { getUsers,deleteUser } from '../../helpers/backend_helper';
import {DestroyAlertHelper,Alert,ToastHelper} from '../../helpers/alerts/alertHelper';
import { getPolicyUser,getStorageCompany } from '../../helpers/api_helper';
import {Container} from "reactstrap";
import ButtonHelper from "../../components/Common/ButtonHelper";
import PasswordModal from "../../components/ChangePasswordModal";

const Users = () => {
    const policy = getPolicyUser();
    const company = getStorageCompany();
    const [pending, setPending] = useState(false);
    const [modal, setModal] = useState({show:false,update:false, showPassword: false});
    const [dataPag, setDataPag] = useState({});
    const [filters,setFilters] = useState({page:1,perPage:20,search:'',orderBy:'id',order:'asc'});
    const [items, setItems] = useState([]);
    const [itemBase, setBase] = useState({
        id: 0,
        name: '',
        email: '',
        profile_id: 0,
        company_id: company.id,
        profile: {
            id: 0,
            name: ''
        },
    })
    const [user, setUser] = useState(itemBase);
	const dispatch = useDispatch()
    useEffect(() => {
        //ToastHelper('mensaje','error')
        let params={params:filters}
        setPending(true)
        getUsers(params).then(response => {
            setItems(response.data)
            setDataPag(response.meta)
            //console.log(response)
            setPending(false)
        }
        )
    }, [filters])
    const addUpd = (row=false) => {
        if(row.id){
            setUser(row)
            setModal({...modal,show:true,update:true})
        }else{
            console.log(itemBase)
            setUser(itemBase)
            setModal({...modal,show:true,update:false})
        }
    }
    const destroy = (id) => {
        DestroyAlertHelper(async confirmed => {
            if (!confirmed) { return; }
            deleteUser(id).then(response => {
                Alert(response.message,response.status)
                if (response.status) {
                    setItems(
                        items.filter(i => i.id != id)
                    );
                }           
            })
        });
    }

    const changePassword = user => {
        setUser(user);
        setModal(prev => ({
            ...prev,
            showPassword: true,
        }));
    }

    const columns = Columns(addUpd,destroy,changePassword);
	document.title = "Usuarios";
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="col-12">
                        <DataTableHelper tittle="Usuarios" columns={columns} items={items} pending={pending} config={dataPag} filters={filters} setFilters={setFilters}>
                            
                                <ButtonHelper
                                    addButon={policy.users.create ? true:false}
                                    actionAddButon={policy.users.create ? addUpd:false}
                                />
                            
                        </DataTableHelper>
                    </div>
                </Container>
                {modal.show &&
                    <AddUpdModal 
                        modal={modal}
                        setModal={setModal}
                        items={items}
                        setItems={setItems}
                        item={user}
                        setItem={setUser}
                    />
                }
                <PasswordModal
                    isOpen={modal.showPassword}
                    setModal={setModal}
                    userId={user && user.id}
                />
            </div>
        </React.Fragment>
    );
};

export default Users;